import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  tag: {
    id: 'product_jp_warranty_tag',
    defaultMessage: "Back Market's warranty",
  },
} as Record<string, I18nDefinition>
